const regCheckGPS = /^[0-9]{2}\.[0-9]*\s*,\s*[0-9]{1,2}\.[0-9]*$/;
const regSplitGPS = /\s*,{1}\s*/;

export { regCheckGPS, regSplitGPS };